import type { Monitor } from "@climatepartner/app-shell/monitoring";
// Deep import: the package barrel pulls @climatepartner/components into every test that tracks an action.
import { useMonitor as useMonitorBase } from "@climatepartner/app-shell/monitoring";

import type { RumActionName } from "./rum-action-names";

export const useMonitor = (): Monitor<RumActionName> => useMonitorBase<RumActionName>();
